export default "__VITE_ASSET__c45944d0__"